import * as tslib_1 from "tslib";
import loadMailboxAutomaticRepliesConfiguration from '../services/loadMailboxAutomaticRepliesConfiguration';
import parseMailboxAutoReplyConfiguration from '../utils/parseMailboxAutoReplyConfiguration';
import updateAutomaticRepliesInitialState from '../data/mutators/updateAutomaticRepliesInitialState';
import { trace } from 'owa-trace';
export default function initLoadMailboxAutomaticRepliesConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var mailboxAutoReplyConfiguration, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, loadMailboxAutomaticRepliesConfiguration()];
                case 1:
                    mailboxAutoReplyConfiguration = _a.sent();
                    // update optionsState with values from mailboxAutoReplyConfiguration
                    updateAutomaticRepliesInitialState(parseMailboxAutoReplyConfiguration(mailboxAutoReplyConfiguration));
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    trace.warn(e_1.message || 'initLoadMailboxAutomaticRepliesConfiguration failed');
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=initLoadMailboxAutomaticRepliesConfiguration.js.map